/**
 * A reusable on off component for toggle switches
 */
import React from 'react';
import { StyledBall } from './OnOffBall.styled';
function OnOffBall(_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'off' : _b, _c = _a.size, size = _c === void 0 ? '20px' : _c;
    return React.createElement(StyledBall, { size: size, variant: variant });
}
export default OnOffBall;
